import { Building2, Hospital, Stethoscope, Pill, FlaskConical, HeartPulse, Users, GraduationCap, Building, Briefcase } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";

const INDUSTRIES = [
  { icon: Hospital, t: "Multi-Specialty Hospitals", d: "300+ bed chains running OPD, IPD, OT, ICU, pharmacy, lab and insurance under one roof." },
  { icon: Stethoscope, t: "Clinics & Polyclinics", d: "Single & multi-doctor practices needing fast-to-deploy OPD + e-Rx + patient app." },
  { icon: Pill, t: "Pharmacy Chains", d: "Retail pharmacies with GST billing, batch tracking and patient refill engagement." },
  { icon: FlaskConical, t: "Diagnostic Labs", d: "Independent labs and radiology centres with sample-to-digital-report workflows." },
  { icon: HeartPulse, t: "Specialty Centres", d: "Dialysis, IVF, dental, dermatology and other vertical specialty care providers." },
  { icon: Users, t: "Telemedicine Networks", d: "Virtual-first care providers with consult, prescription and pharmacy delivery." },
  { icon: GraduationCap, t: "Medical Education", d: "Teaching hospitals with resident workflows, audit trails and case libraries." },
  { icon: Building, t: "Corporate Healthcare", d: "Employee health cards, on-site clinics, checkup programs and EAP." },
  { icon: Briefcase, t: "Insurance & TPAs", d: "Cashless claim flows, document exchange and audit-ready reporting." },
  { icon: Building2, t: "Government / Public Health", d: "Public health programs needing scale and data residency." },
];

export default function Industries() {
  return (
    <div data-testid="page-industries">
      <section className="relative bg-[color:var(--paper-2)] overflow-hidden">
        <div className="absolute inset-0 bg-grid-light opacity-40" />
        <div className="relative container-x pt-4 md:pt-6 lg:pt-8 pb-12">
          <SectionHeader
            eyebrow="Industries"
            title="Built for every corner"
            titleAccent="of the healthcare value chain."
            subtitle="From a single GP clinic to a 20-state hospital network — the platform scales with your ambition."
          />
        </div>
      </section>

      <section className="section-y bg-white">
        <div className="container-x grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {INDUSTRIES.map((it, i) => (
            <div
              key={it.t}
              data-testid={`industry-${i + 1}`}
              className="group rounded-2xl border border-slate-200 bg-white p-6 hover:-translate-y-1 hover:shadow-xl hover:border-[color:var(--brand)] transition-all"
            >
              <div className="w-11 h-11 rounded-xl bg-[color:var(--brand-soft)] grid place-items-center text-[color:var(--brand)] group-hover:bg-[color:var(--brand)] group-hover:text-white transition">
                <it.icon className="w-5 h-5" />
              </div>
              <h3 className="mt-5 text-xl font-bold">{it.t}</h3>
              <p className="mt-2 text-sm text-slate-600">{it.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
